export const mecCodeMask = value => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{8})\d+?$/, '$1')
}

export const eTicketMask = value => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{13})\d+?$/, '$1')
}

export const pesoMask = value => {
  return value
    .replace(/\D+/g, '')
}

export const numberMask = value => {
    return value
      .replace(/\D+/g, '')
}

export const diaMesMask = value => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
}

export const deMask = value => {
  return value
    .replace(/\s/g, '')
    .replace(/(\d{2}\D[A-zÀ-ÿ]{2}\d{8})\d+?$/, '$1')
}

export const sedexMask = value => {
  return value
    .replace(/\s/g, '')
    .replace(/^[^a-zA-Z]/g, '')
    .replace(/^([a-zA-Z]{1})[^a-zA-Z]+?$/g, '$1')
    .replace(/^([a-zA-Z]{2}\d{0,8})\D+?$/,'$1')
    .replace(/^([a-zA-Z]{2}\d{9})[^a-zA-Z]+?$/,'$1')
    .replace(/^([a-zA-Z]{2}\d{9}[a-zA-Z]{1})[^a-zA-Z]+?$/,'$1')
    .replace(/^([a-zA-Z]{2}\d{9}[a-zA-Z]{2}).+?$/,'$1').toUpperCase()
}
export const codigoCartaoMask = (value) => {
  const cleaned = value
    .replace(/\s/g, '')               // remove espaços
    .replace(/[^a-zA-Z0-9]/g, '')     // remove caracteres especiais
    .toUpperCase();                   // tudo maiúsculo

  const letras = cleaned.replace(/[^A-Z]/g, '').slice(0, 2);   // até 2 letras no início
  const numeros = cleaned.slice(letras.length).replace(/\D/g, '').slice(0, 14); // até 14 números depois

  return letras + numeros;
};

export const objetoPostalMask = (value) => {
  return value
    .replace(/\s/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .replace(/^([^a-zA-Z]*)/, '')
    .replace(/^([a-zA-Z]{2})[^0-9]/, '$1')
    .replace(/^([a-zA-Z]{2}\d{0,14}).*/, '$1')
    .toUpperCase();
}

export const documentoEnvioMask = (value) => {
  return value
    .replace(/\s/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .replace(/^([^0-9]*)/, '')
    .replace(/^([a-zA-Z]{2})[^0-9]*/, '$1')
    .replace(/^([a-zA-Z]{2}[a-zA-Z0-9]{0,10}).*/, '$1')
    .slice(0, 12)
    .toUpperCase();
}


export const nivelMask = (value) => {
  const match = value.match(/[123]/);

  return match ? match[0] : '';
}

export const  qtdDeMask = value => {
  return value
    .replace(/[^@0-9]/g, '')
}
  export const cpfMask = value => {
    if (value.includes('@')) {
      value = value.replace(/[^@]/g, '').slice(0, 2);
    } else {
      value = value.replace(/\D/g, '')
      value = value.replace(/(\d{3})(\d)/, '$1.$2')
      value = value.replace(/(\d{3})(\d)/, '$1.$2')
      value = value.replace(/(\d{3})(\d{1,2})/, '$1-$2')
      value = value.replace(/(-\d{2})\d+?$/, '$1')
    }
    return value
  }


export const dataMask = value => {
  if (value.includes('@')) {
    value = value.replace(/[^@]/g, '@@').slice(0, 2);
  } else
  {
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{2})(\d)/, '$1/$2')
    value = value.replace(/(\d{2})(\d)/, '$1/$2')
    value = value.replace(/(\d{4})\d+?$/, '$1');
  }

  return value
}

export const telefoneMask = value => {
  if (value.includes('@')) {
    value = value.replace(/[^@]/g, '').slice(0, 2);
  } else
  {
    value = value.replace(/\D/g, '').slice(0, 9);
  }

  return value
}

export const dddMask = value => {
  if (value.includes('@')) {
    value = value.replace(/[^@]/g, '').slice(0, 2);
  } else
  {
    value = value.replace(/\D/g, '').slice(0, 2);
  }

  return value
}

export const notaMask = value => {
  if (value.includes('@')) {
    value = value.replace(/[^@]/g, '').slice(0, 2);
  } else
  {
    value = value.replace(/\D/g, '').slice(0, 2);
  }
  return value
}
export const nomeMask = value => {
  if (value.includes('@')) {
    value = value.replace(/[^@]/g, '').slice(0, 2);
  } else {
    value = value.replace(/[^A-Za-z\s]/g, '').slice(0, 45);
  }
  return value;
};

export const envelopePostalMask = (value) => {
  return value
    .replace(/\s/g, '')
    .replace(/^[^a-zA-Z]/g, '')
    .replace(/^([a-zA-Z]{1})[^a-zA-Z]+?$/, '$1')
    .replace(/^([a-zA-Z]{2}\d{0,8})\D+?$/, '$1')
    .replace(/^([a-zA-Z]{2}\d{9})[^a-zA-Z]+?$/, '$1')
    .replace(/^([a-zA-Z]{2}\d{9}[a-zA-Z]{1})[^a-zA-Z]+?$/, '$1')
    .replace(/^([a-zA-Z]{2}\d{9}[a-zA-Z]{2}).+?$/, '$1')
    .toUpperCase();
};



